import * as api from '@/api'
import manifest from '@/utils/manifest'
import store from '@/store'
import dexie from '@/utils/dexie';
import * as general from '@/utils/general'

start();

async function start() {
  general.debug('start', window.localStorage);
  general.debug(navigator);
  general.debug(navigator.storage);
  
  general.debug(1024 * 1024 * 5 - unescape(encodeURIComponent(JSON.stringify(localStorage))).length);
  if (navigator.storage) {
    let storage = await navigator.storage.estimate();
    general.debugMobile(storage);
    general.debugMobile('quota', storage.quota / 1024 / 1024 / 1024);
    general.debugMobile(`using ${storage.usage / 1024 / 1024 / 1024} out of ${storage.quota / 1024 / 1024 / 1024}, or ${storage.usage / storage.quota * 100}%`);
  }

  // settings
  checkSettings();
  // manifest
  await manifest.readAll();
}

async function checkSettings() {  
  if (localStorage && localStorage.getItem('settingsUpdated')) {
    let ms = new Date - new Date(localStorage.getItem('settingsUpdated'));
    if (ms > 60 * 60 * 1000) { // 1 HOUR
      await dexie.settings.clear();
    }
  } else {
    await dexie.settings.clear();
  }
  if (dexie.settings) {
    store.state.settings = await dexie.settings.get(1);
  }
  if (!store.state.settings) {
    await fetchSettings();
  }
  general.debug('settings', store.state.settings);
}

async function fetchSettings() {
  console.time('fetchSettings');
  await api.getSettings()
    .then(response => {
      general.debug('settings fetch', response);
      if (response) {
        store.state.settings = response;
      }
    });
  try {
    await dexie.settings.clear();
    await dexie.settings.add(store.state.settings, 1);
    if (localStorage) {
      localStorage.setItem('settingsUpdated', new Date);
    }
  } catch (e) {
    console.error('catch: ', e);
  }
  general.timeEnd('fetchSettings');
}
